import {
  ADD_SUPPORT_MATERIAL,
  ADD_SUPPORT_MATERIAL_SUCCESS,
  ADD_SUPPORT_MATERIAL_CLEAN,
  ADD_SUPPORT_MATERIAL_ERROR,
} from "./actionTypes"

export const addSupportMaterial = (form, request) => ({
  type: ADD_SUPPORT_MATERIAL,
  payload: { form, request },
})

export const addSupportMaterialSuccess = supportMaterial => {
  return {
    type: ADD_SUPPORT_MATERIAL_SUCCESS,
    payload: { supportMaterial },
  }
}

export const addSupportMaterialClean = () => {
  return {
    type: ADD_SUPPORT_MATERIAL_CLEAN,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: ADD_SUPPORT_MATERIAL_ERROR,
    payload: error,
  }
}
